import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

var Notification = window.Notification || window.mozNotification || window.webkitNotification;

// Verifica si Notification existe antes de pedir permisos
if (Notification && typeof Notification.requestPermission === "function") {
    Notification.requestPermission(function (permission) {
        // console.log(permission);
    });
} else {
    // Manejo alternativo para navegadores no soportados
    console.warn("Las notificaciones no están soportadas en este navegador.");
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
